import { Directive } from '@angular/core';

@Directive({
  selector: '[nzMentionSuggestion]'
})
export class NzMentionSuggestionDirective {}
